import { useEffect, useState } from 'react';
import { ArrowLeftIcon } from '@heroicons/react/24/solid';
import clsx from 'clsx';
import { Outlet, useMatch, useNavigate } from 'react-router';

import { usePromoCodeContext } from 'contexts/PromoCodeContext';
import Progress from 'honeydew/Progress';
import { FEATURE_FLAG_NAMES, useAmplitudeFeatureFlag } from 'hooks/useFeatureFlag';
import { STICKY_SHOP_NAVIGATION_STYLES } from 'hooks/useStickyShopNavigation';
import { trackExistingUserRedirect } from 'utils/analyticsUtils';
import { getQuizStepsOrdered, removeSignupLocalStorage, setSignupLocalStorage } from 'utils/signupUtils';

export default function SignupQuizLayout() {
    const { renderSignupNanoBanner } = usePromoCodeContext();

    const navigate = useNavigate();
    const pathMatch = useMatch('/join/quiz/:quizStep');
    const [showBackArrow, setShowBackArrow] = useState(true);

    const { variantAssignment: prefQuizBackTestVariant } = useAmplitudeFeatureFlag({
        flagName: FEATURE_FLAG_NAMES.PREF_QUIZ_BACK_TEST,
    });

    const quizSteps = getQuizStepsOrdered(prefQuizBackTestVariant);
    const quizStepIndex = quizSteps.indexOf(pathMatch.params.quizStep);
    const quizProgress = ((quizStepIndex + 1) / quizSteps.length) * 100;

    const handleBackClick = () => {
        if (quizStepIndex === 0) {
            setSignupLocalStorage({ path: '/join' });
            navigate('/join');
        } else {
            navigate(quizSteps[quizStepIndex - 1]);
        }
    };

    const handleContinueClick = () => {
        const nextQuizPath = `/join/quiz/${quizSteps[quizStepIndex + 1]}`;
        setSignupLocalStorage({ path: nextQuizPath });
        navigate(nextQuizPath);
    };

    useEffect(() => {
        if (quizStepIndex === -1) {
            trackExistingUserRedirect({ destination: '/join' });
            removeSignupLocalStorage();
            navigate('/join');
        }
    }, []);

    return (
        <main>
            <div
                className={clsx('mx-auto flex w-full max-w-[600px] items-center gap-10 px-25', {
                    [STICKY_SHOP_NAVIGATION_STYLES.paddingTopSignupNanobanner]: renderSignupNanoBanner,
                    [STICKY_SHOP_NAVIGATION_STYLES.paddingTopSignupNoNanobanner]: !renderSignupNanoBanner,
                })}
            >
                <div className="h-[24px]">
                    {showBackArrow && (
                        <button onClick={handleBackClick} type="button">
                            <ArrowLeftIcon className="h-[24px] w-[24px]" />
                            <span className="sr-only">Go back</span>
                        </button>
                    )}
                </div>
                <Progress progress={quizProgress} width="full" />
            </div>
            <Outlet
                context={{
                    handleContinueClick,
                    setShowBackArrow,
                    prefQuizBackTestVariant,
                }}
            />
        </main>
    );
}
